import actionTypes from './actionTypes';

export const fetch = () => ({
  type: actionTypes.FETCH,
  payload: {},
});

export const fetching = () => ({
  type: actionTypes.FETCHING,
});

export const fetched = (data) => ({
  type: actionTypes.FETCHED,
  payload: {
    data,
  },
});

export const upload = (values) => ({
  type: actionTypes.UPLOAD,
  payload: {
    values,
  },
});

export const setPreviewDataStatus = (status) => ({
  type: actionTypes.APPROVE_PREVIEW_DATA,
  payload: {
    status,
  },
});

export const setPreviewData = (data) => ({
  type: actionTypes.SET_PREVIEW_DATA,
  payload: {
    data,
  },
});

export const setPreviewDataErrors = (errors) => ({
  type: actionTypes.SET_PREVIEW_ERRORS,
  payload: {
    errors,
  },
});
